import { useState, useEffect } from "react"
import Link from "next/link"
import { useRouter } from "next/router"
import FindStoreUtilNav from "@/components/FindStoreUtilNav/v1/FindStoreUtilNav"
import AuthUtilityNav from "@/components/Default/AuthUtilityNav/v1/AuthUtilityNav"

import CountryUtilNav from "@/components/Default/CountryUtilNav/v1/CountryUtilNav"
import MiniCart from "@/components/Shared/MiniCart/v1/MiniCart"
import { isElementExcluded, toggeleBodyScroll } from "@/utils/helper"
import styles from "@/components/Shared/index.module.scss"
import {
  selectAuthState,
  setAuthModalVisibility,
} from "@/store/features/authSlice"
import {
  selectFavoritesState,
  getFavorites,
} from "@/store/features/favoritesSlice"

import { useDispatch, useSelector } from "react-redux"

import utilityStyles from "@/components/Shared/UtilityWidgets/v1/UtilityWidgets.module.scss"
import { selectGenericState } from "@/store/features/genericSlice"
import useWindowDimensions from "@/hooks/useWindowDimensions"

const UtilityNavHeader = ({ data, eventHandler }) => {
  const router = useRouter()
  const { store: { store: { zipCodeContent = "" } = {} } = {} } = data

  const {
    store: { isOpen, mainCategoryActive, isRegionOpen, isAuthNavOpen },
    callbacks: {
      setRegionNav = () => console.log("Event Not Defined"),
      setAuthNav = () => console.log("Event Not Defined"),
    },
  } = eventHandler
  const [currentPagePath, setCurrentPagePath] = useState("/")
  useEffect(() => {
    if (router.locale && router.pathname) {
      setCurrentPagePath("/" + router.locale + router.asPath)
    }
  }, [])
  const { winWidth } = useWindowDimensions()
  const { datalayerPageName } = useSelector(selectGenericState)
  const [findAStoreShow, setFindAStoreShow] = useState(false)
  const [findAStoreActive, setFindAStoreActive] = useState(false)
  const { isAuth } = useSelector(selectAuthState)
  const { favorites } = useSelector(selectFavoritesState)
  const [authNavShow, setAuthNavShow] = useState(false)
  const [authNavActive, setAuthNavActive] = useState(false)
  const [favoritesPage, setFavoritesPage] = useState([])
  const [countryNavShow, setCountryNavShow] = useState(false)
  const [countryNavActive, setCountryNavActive] = useState(false)
  eventHandler.callbacks.toggleFindAStore = () => {
    setFindAStoreActive(false)
  }
  useEffect(() => {
    if (findAStoreShow) {
      setFindAStoreActive(true)
    }
    if (authNavShow) {
      setAuthNavActive(true)
    }
    if (countryNavShow) {
      setCountryNavActive(true)
    }
  }, [findAStoreShow, authNavShow, countryNavShow])

  useEffect(() => {
    if (isAuth) {
      dispatch(getFavorites())
        .unwrap()
        .then(rsp => {
          if (rsp && rsp !== null) {
            setFavoritesPage(rsp.lineItems)
          } else {
            setFavoritesPage([])
          }
        })
    }
  }, [isAuth])
  useEffect(() => {
    if (favorites?.lineItems && favorites?.lineItems.length > 0) {
      setFavoritesPage(favorites?.lineItems)
    } else {
      setFavoritesPage([])
    }
  }, [favorites])

  useEffect(() => {
    if (!findAStoreActive) {
      setTimeout(() => {
        setFindAStoreShow(false)
      }, 1000)
    }
    if (!authNavActive) {
      setTimeout(() => {
        setAuthNavShow(false)
      }, 1000)
    }
    if (!countryNavActive) {
      if (winWidth <= 1200) {
        setCountryNavShow(false)
      } else {
        setTimeout(() => {
          setCountryNavShow(false)
        }, 1000)
      }
    }
  }, [findAStoreActive, authNavActive, countryNavActive])

  const toggleFindAStore = () => {
    if (!findAStoreShow) {
      setFindAStoreShow(true)
      toggeleBodyScroll(true)
    } else {
      setFindAStoreActive(false)
      toggeleBodyScroll(false)
    }
  }

  useEffect(() => {
    const handleClickOutside = event => {
      const isUserIconClick = event.target.closest(".auth-nav--active img")
      const isUserNavItemClick = event.target.closest(
        ".auth-nav--active .auth-nav__user"
      )
      if (authNavShow && !isUserIconClick && !isUserNavItemClick) {
        setAuthNavShow(false)
      }
    }
    document.addEventListener("click", handleClickOutside)
    return () => {
      document.removeEventListener("click", handleClickOutside)
    }
  }, [authNavShow])

  useEffect(() => {
    const styleEle = document.querySelector(".auth-nav")
    const backStyleElement = document.querySelector(
      ".ann-sacks-main-menu.header-container.ann-sacks-tab-bar>.cmp-container"
    )
    const closeIconElement = document.querySelector(
      ".icon-close-medium.icon-close"
    )
    const findStoreElement = document.querySelector(".gbh-nav__findStore>a")

    if (authNavShow) {
      styleEle.classList.add("auth-nav--active")
      backStyleElement?.classList?.add("auth-nav-header")
      closeIconElement?.classList?.add("auth-nav-icon")
      findStoreElement?.classList?.add("auth-nav-icon")
    } else {
      styleEle.classList.remove("auth-nav--active")
      backStyleElement?.classList?.remove("auth-nav-header")
      closeIconElement?.classList?.remove("auth-nav-icon")
      findStoreElement?.classList?.remove("auth-nav-icon")
    }
  }, [authNavShow])

  const toggleAuthNav = () => {
    if (!authNavShow) {
      setAuthNavShow(true)
      toggeleBodyScroll(true)
    } else {
      setAuthNavActive(false)
      toggeleBodyScroll(false)
    }
  }

  const toggleCountryNav = () => {
    if (!countryNavActive) {
      setCountryNavShow(true)
      toggeleBodyScroll(true)
    } else {
      setCountryNavActive(false)
      toggeleBodyScroll(false)
    }
  }

  const clickEvent = e => {
    if (
      !isElementExcluded(e, ["header-container", "modal-popup", "auth-modal"])
    ) {
      setAuthNavActive(false)
      setFindAStoreActive(false)
      setCountryNavActive(false)
      toggeleBodyScroll(false)
    }
  }

  useEffect(() => {
    if (findAStoreActive) {
      setAuthNavActive(false)
      setCountryNavActive(false)
      document.addEventListener("click", clickEvent)
    } else {
      document.removeEventListener("click", clickEvent)
    }

    return () => document.removeEventListener("click", clickEvent)
  }, [findAStoreActive])

  useEffect(() => {
    if (authNavActive) {
      setFindAStoreActive(false)
      setCountryNavActive(false)
      document.addEventListener("click", clickEvent)
    } else {
      document.removeEventListener("click", clickEvent)
    }

    return () => document.removeEventListener("click", clickEvent)
  }, [authNavActive])

  useEffect(() => {
    if (countryNavActive) {
      setAuthNavActive(false)
      setFindAStoreActive(false)
      document.addEventListener("click", clickEvent)
    } else {
      document.removeEventListener("click", clickEvent)
    }

    return () => document.removeEventListener("click", clickEvent)
  }, [countryNavActive])
  const style = { display: "list-item" }
  const displayNone = { display: "none" }
  const dispatch = useDispatch()
  const onClickSignIn = () => {
    dispatch(setAuthModalVisibility({ show: true }))
  }

  const onAuthMenuClick = payload => {
    setAuthNavActive(payload)
    setAuthNav(payload)
  }
  // const [loadUtilityWidgets, setloadUtilityWidgets] = useState(true)
  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setloadUtilityWidgets(false)
  //   }, 5000)
  //   return () => clearTimeout(timer)
  // }, [])
  return (
    <div className={styles.utilityNavHeaderWrapper}>
      <div className="utilitynavheader">
        <div className="gbh-utility-nav">
          <div className="gbh-utility-navbar">
            <ul role="list">
              <li
                className="gbh-nav__findStore"
                {...(isOpen &&
                  !mainCategoryActive &&
                  !isRegionOpen &&
                  !isAuthNavOpen
                  ? { style: style }
                  : {})}
              >
                <a
                  role="button"
                  tabIndex="0"
                  aria-live="polite"
                  aria-labelledby="find-ada"
                  className={
                    "gbh-data-layer gbh-nav__findStore--link cmp-find-place"
                  }
                  onClick={() => toggleFindAStore()}
                  data-gbh-data-layer={`{"eventAction":"find a showroom","eventName":"find a showroom","eventType":"find a showroom","internalLinkName":"find a showroom","internalLinkPosition":"find a showroom","internalLinkType":"global header:navigation","internalLinkZoneName":"${datalayerPageName}${datalayerPageName ? ":" : ""
                    }global header","internalLinkURL":"n/a","clickInternalLinks":"true"}`}
                >
                  Find a Showroom
                </a>
                <FindStoreUtilNav
                  show={findAStoreShow}
                  active={findAStoreActive}
                  eventHandler={eventHandler}
                  zipCodeContent={zipCodeContent}
                />
              </li>
              <span id="country-ada" style={displayNone}>
                Country Selector{" "}
                {process.env.NEXT_PUBLIC_COUNTRYNAME || data?.country} -{" "}
              </span>
              {/* the below commented lines are based on this ticket:AS-6619 */}
              {/* <li
                className="gbh-nav__region region_arrowdropdown"
                id={
                  process.env.NEXT_PUBLIC_COUNTRYNAME.toLowerCase()
                    .split(" ")
                    .join("_") ||
                  data?.country.toLowerCase().split(" ").join("_")
                }
                {...(isOpen && !mainCategoryActive ? { style: style } : {})}
              >
                <a
                  role="button"
                  tabIndex="0"
                  aria-labelledby="country-ada"
                  aria-expanded={countryNavActive}
                  onClick={() => {
                    setRegionNav(true)
                    toggleCountryNav()
                  }}
                  className={`gbh-data-layer gbh-nav__region--link active-country ${
                    countryNavActive ? "expand" : ""
                  } `}
                  data-gbh-data-layer={`{"clickInternalLinks":"true","internalLinkPosition":"global header","internalLinkZoneName":"${datalayerPageName}:global header","internalLinkURL":"n/a","internalLinkName":"${(
                    process.env.NEXT_PUBLIC_COUNTRYNAME || data?.country
                  )?.toLowerCase()} - ${(
                    process.env.NEXT_PUBLIC_LANGUAGENAME || data?.language
                  )?.toLowerCase()}","eventName":"country select","internalLinkType":"global header : navigation","eventType":"click","eventAction":"country select"}`}
                >
                  {process.env.NEXT_PUBLIC_COUNTRYNAME || data?.country} -{" "}
                  {process.env.NEXT_PUBLIC_LANGUAGENAME || data?.language}
                </a>

                {data[":items"]?.countryselector && (
                  <CountryUtilNav
                    show={countryNavShow}
                    countryselector={data[":items"]?.countryselector}
                    active={countryNavActive}
                    eventHandler={eventHandler}
                    toggleCountryNav={toggleCountryNav}
                    datalayerPageName={datalayerPageName}
                  />
                )}
              </li> */}
              <li
                className="gbh-nav__signin"
                {...(isOpen && !mainCategoryActive && !isRegionOpen
                  ? { style: style }
                  : {})}
              >
                <div className={utilityStyles.utilityWidgetsWrapper}>
                   <div
                    role="list"
                    className="utility-widgets utility-widgets__brand-switcher"
                    style={{ display:"flex" }}
                  >
                    <AuthUtilityNav
                      show={authNavShow}
                      active={authNavActive}
                      toggleAuthNav={toggleAuthNav}
                      setAuthNav={setAuthNav}
                      onAuthMenuClick={onAuthMenuClick}
                    />
                    {winWidth > 1200 && (
                      <>
                        <div role="listitem" className="wishlist-widget">
                          <Link
                            href={
                              isAuth
                                ? "/my-account/my-favorites"
                                : '#'
                            }
                            aria-label="View your wishlist"
                            className="gbh-data-layer"
                            data-gbh-data-layer={`{"eventName":"wishlist icon","eventAction":"wishlist icon","internalLinkName":"wishlist","internalLinkType":"global header:wishlist","internalLinkZoneName":"global header","clickInternalLinks":"true","eventType":"global header","internalLinkURL":"n/a","internalLinkPosition":"global header wishlist","eventMsg":"n/a","eventStatus":"n/a"}`}
                            onClick={!isAuth && onClickSignIn}
                          >
                            <img
                              alt="View your wishlist"
                              aria-hidden="true"
                              role="presentation"
                              src={
                                favoritesPage && favoritesPage.length > 0
                                  ? "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTVweCIgaGVpZ2h0PSIxNHB4IiB2aWV3Qm94PSIwIDAgMTUgMTQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+SWNvbi9XaXNobGlzdDwvdGl0bGU+CiAgICA8ZyBpZD0iQjEtQ29tcGFyZSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9Ikljb24vV2lzaGxpc3QiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuMDAwMDAwLCAtOC4wMDAwMDApIiBmaWxsPSIjRkZGRkZGIj4KICAgICAgICAgICAgPHBhdGggZD0iTTguMTQwNjA3MTQsOS42ODg0ODE5NyBMNy41MDEsMTAuMzM0IEw2Ljg2MTU5MzY5LDkuNjg4NDgxOTcgQzUuMjkyNDIzNTIsOC4xMDM4MzkzNCAyLjc0NjI0NDc5LDguMTAzODM5MzQgMS4xNzcwNzQ2Myw5LjY4ODQ4MTk3IEMtMC4zNDg3ODE5NTgsMTEuMjI5MzgzOSAtMC4zOTYyNTE5NTksMTMuNzE4NTgzNCAxLjA2NDMyMjM2LDE1LjI5NzA0NDIgTDEuMTcwNzE4NTIsMTUuNDA4NTcwNyBMNy41MDExMTM0NCwyMS44MDE1MDMzIEwxMy44MDg0ODM5LDE1LjQzMjE5OTggTDEzLjkxNTE4NzgsMTUuMzIxMTQwOCBDMTUuMzk1NTk2OCwxMy43MjE3MTI1IDE1LjM1Mzk3MDMsMTEuMjMyNDAxIDEzLjgyNTEyNjIsOS42ODg0ODE5NyBDMTIuMjU1OTU2LDguMTAzODM5MzQgOS43MDk3NzczMSw4LjEwMzgzOTM0IDguMTQwNjA3MTQsOS42ODg0ODE5NyBaIiBpZD0iUGF0aCI+PC9wYXRoPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"
                                  : "data:image/svg+xml;base64,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"
                              }
                            />
                          </Link>
                        </div>

                        <div role="listitem" className="cart-indicator-widget">
                          <MiniCart
                            eventHandler={eventHandler}
                            source={"from desk"}
                          />
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}

export default UtilityNavHeader
